import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ReplaySubject } from 'rxjs';

import { FeatureToggleService } from 'ish-core/feature-toggle.module';
import { Brand } from 'ish-core/models/brand/brand.model';
import { PipesModule } from 'ish-core/pipes.module';

@Component({
  selector: 'ish-suggest-brands',
  templateUrl: './suggest-brands.component.html',
  imports: [CommonModule, PipesModule, TranslateModule, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestBrandsComponent {
  private fratureToggleService = inject(FeatureToggleService);

  readonly brands = input<Brand[]>(undefined);
  readonly maxAutoSuggests = input<number>(undefined);
  readonly inputTerms$ = input(new ReplaySubject<string>(1));
  readonly routeChange = output<string>(); //DIAS-CUSTOMIZATION

  handleInputFocus(brandName: string): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.routeChange.emit(brandName);
  }
  /**DIAS-CUSTOMIZATION-STARTS */
  isFeatureEnabled$() {
    return this.fratureToggleService.enabled$('sparqueSearch');
  }
  /**DIAS-CUSTOMIZATION-ENDS */
}
